module.exports = __webpack_public_path__ + "img/xx.1327e3d2.png";